import produce from 'immer';
import { handleActions } from 'redux-actions';
import { filter } from 'lodash';
import actions from './actions';
import {
  NOTICE_STORE_INFO_MODEL,
  NOTICE_STORE_LIST_FILTER_OPTION_MODEL,
  NOTICE_STORE_LIST_SORT_OPTION_MODEL,
} from './models';
import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../../app/models';
import { updateStoreWithPath } from '../../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  /**
   *  상점 공지사항에서 사용되는 MODEL
   */
  noticeStore: {
    /**
     *  상점 공지사항 리스트
     */
    noticeStoreList: {
      /**
       *  리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: NOTICE_STORE_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션 리스트
       */
      sortOption: NOTICE_STORE_LIST_SORT_OPTION_MODEL,
      /**
       *  리스트 pagination
       */
      pagination: LIST_PAGINATION_MODEL,
      /**
       *  집계 데이터
       */
      summary: LIST_SUMMARY_MODEL,
    },

    /**
     *  상점 공지사항 등록/편집에서 사용되는 MODEL
     */
    noticeStoreInfo: NOTICE_STORE_INFO_MODEL,

    /**
     *  상점 공지사항 라벨 리스트
     */
    noticeStoreLabelList: [],
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [상점 공지사항] 상점 공지사항 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [상점 공지사항 리스트] 상점 공지사항 리스트 가져오기
     */
    [actions.GET_NOTICE_STORE_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상점 공지사항 리스트
         */
        draft.noticeStore.noticeStoreList = action.payload.noticeStoreList;
      });
    },

    /**
     *  [상점 공지사항 리스트] 선택된 상점 공지사항 삭제하기
     */
    [actions.DELETE_NOTICE_STORE_REQUEST]: (state, action) => {
      return produce(state, (draft) => {
        draft.noticeStore.noticeStoreList.list = filter(
          draft.noticeStore.noticeStoreList.list,
          (item) => item.id !== action.payload.noticeStoreId,
        );
      });
    },

    /**
     *  [상점 공지사항 등록] 상점 공지사항 등록시 필요한 정보 가져오기
     */
    [actions.PREPARE_ADD_NOTICE_STORE_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상점 공지사항 라벨 리스트
         */
        draft.noticeStore.noticeStoreLabelList = action.payload.noticeStoreLabelList;
        /**
         *  상점 공지사항 상세 초기화
         */
        draft.noticeStore.noticeStoreInfo = { ...initialState.noticeStore.noticeStoreInfo };
      });
    },

    /**
     *  [상점 공지사항 편집] 상점 공지사항 요청하기
     */
    [actions.GET_NOTICE_STORE_REQUEST]: (state) => {
      return produce(state, (draft) => {
        /**
         *  상점 공지사항 상세 초기화
         */
        draft.noticeStore.noticeStoreInfo = { ...initialState.noticeStore.noticeStoreInfo };
      });
    },

    [actions.GET_NOTICE_STORE_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  상점 공지사항 라벨 리스트
         */
        draft.noticeStore.noticeStoreLabelList = action.payload.noticeStoreLabelList;
        /**
         *  상점 공지사항 상세
         */
        draft.noticeStore.noticeStoreInfo = action.payload.noticeStoreInfo;
      });
    },
  },
  initialState,
);
